// src/components/AccessDeniedModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function AccessDeniedModal({ show, onConfirm }) {
  return (
    <Modal centered show={show} onHide={onConfirm}>
      <Modal.Header closeButton>
        <Modal.Title>Accès modifié</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Vos droits d’accès ont été modifiés. Vous devez vous reconnecter.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onConfirm}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
